import styled from 'styled-components';

export default styled.button`
  display: inline-block;
  background: none;
  flex: 1;
  outline: 0;
  border: 0;
  margin: 0 8px;
  max-width: 44px;
  padding: 10px 0;
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;
